/**
 * The third-party assistants a reader can take a docs page to, from its menu (PageMenu): each a new
 * conversation, in a new tab, that starts by reading the page's Markdown. Keshav's ruling of 3 October 2026
 * lets the developer site name these products, here and only here (copy.test.ts holds it to this file);
 * Bash itself is never called by their names. The prefill URLs are the ones Mintlify's page menu opens
 * (chat.openai.com now redirects to chatgpt.com, keeping its query).
 */
export const OPEN_IN: ReadonlyArray<{
  name: string;
  url: (prompt: string) => string;
}> = [
  {
    name: "ChatGPT",
    url: (prompt) =>
      `https://chatgpt.com/?hints=search&q=${encodeURIComponent(prompt)}`,
  },
  {
    name: "Claude",
    url: (prompt) => `https://claude.ai/new?q=${encodeURIComponent(prompt)}`,
  },
];

/** What a new conversation about a page opens with: read its Markdown, at its absolute URL. */
export const askAbout = (markdownUrl: string): string =>
  `Read ${markdownUrl} so I can ask you about it.`;
